// Trulux About Us — Scroll-triggered slide animations
(function() {
  function initAboutAnimations() {
    const elements = document.querySelectorAll('.slide-from-left, .slide-from-right');
    
    if (!elements.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Slight delay for right element so left comes in first
          if (entry.target.classList.contains('slide-from-right')) {
            setTimeout(function() {
              entry.target.classList.add('is-visible');
            }, 200);
          } else {
            entry.target.classList.add('is-visible');
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutAnimations);
  } else {
    initAboutAnimations();
  }
})();
